
import { mapGetters } from 'vuex'
import { lengthInUtf8Bytes, humanFileSize } from '~/util/string'
import { summaryCopyCaption } from '~/util/summary-copy'

export default {
    props: {
        activity: {
            type: Object,
            default: null
        },
    },
    data () {
        return { context: null, copy: null }
    },
    computed: {
        ...mapGetters(['user']),
        // The summary copy this activity shows (flow/consults/summary_copies.py):
        // a send's own, or for a link-only send from before copies existed the
        // one rendered later. The email's own link expires, this one does not.
        hiddenAttachment () {
            if (!this.copy) { return null }
            return {
                kind: this.copy.kind,
                filename: this.copy.filename,
                url: `${this.hostUrl}${this.copy.url}`,
                caption: summaryCopyCaption(this.copy, this.$moment),
            }
        },
    },
    watch: {
        activity () {
            this.loadContext()
            this.loadCopy()
        }
    },
    mounted () {
        this.loadCopy()
        return this.loadContext()
    },
    methods: {
        humanFileSize,
        lengthInUtf8Bytes,
        async loadCopy () {
            this.copy = null
            if (!['send_summary', 'render_summary'].includes(this.activity?.activity)) { return }
            const resp = await this.$try('$get', `/api/accounts/activity/${this.activity.id}/summary-copy/`, { alert: false, spinner: false })
            this.copy = resp && !resp.error ? resp : null
        },
        async loadContext () {
            // if less than 1mb
            if (this.activity?.context?.file) {
                const res = await this.$try('$get', `/api/accounts/activity/${this.activity.id}/context.json`)
                if (res?.error) {
                    this.context = this.activity.context
                } else {
                    this.context = res
                }
            } else {
                this.context = this.activity.context
            }
        }
    }
}
